import React, { useMemo } from "react";
import usePagination, { Dots } from "../../CustomHooks/usePagination";
import "./Paggination.scss"
import { NextIcon, PrevIcon } from "../Icons/CheckOutLogo";
import { lang } from "../../models";
import { handleLangugeDirection } from "../commonFunctions";
interface props {
    onPageChange: (num: any) => void;
    totalCount: number,
    pageSize: number,
    currentPage: number,
    searchKeyword?: any,
    auth?: any,
    setCurrentpage: (CurrentPage: number) => void,
}


const CustomPagination = (props: props) => {

    const { onPageChange, currentPage, pageSize, totalCount, searchKeyword, auth } = props;

    const onPageClick = (PageNum: number) => {

        onPageChange(PageNum)
        /*  console.log(searchKeyword) */
        //dispatch(getListOfMerchants(PageNum, pageSize, auth.token, searchKeyword, auth?.partnerId))
    }

    const sibilingCount = 1;
    const [paginationRange]: any = usePagination({ totalCount, pageSize, sibilingCount, currentPage });

    if (currentPage === 0 || paginationRange?.length < 2) {
        return null;
    }

    const onNext = (currentPage: number) => {
        /*  console.log(searchKeyword) */
        onPageChange(currentPage)

        //dispatch(getListOfMerchants((currentPage), pageSize, auth.token, searchKeyword, auth?.partnerId))
    }
    const onPrevious = (currentPage: number) => {
        /* console.log(searchKeyword) */
        onPageChange((currentPage - 2))

        //dispatch(getListOfMerchants((currentPage - 2), pageSize, auth.token, searchKeyword, auth?.partnerId))

    }

    const lastPage = paginationRange[paginationRange?.length - 1];


    const Arrow = (): any => {

        const preIcon = <PrevIcon />;
        const NexIcon = <NextIcon />;
        const handleArrowIcon = (direction: any) => {
            return {
                left: <span onClick={() => { onPrevious(currentPage) }} > {direction === 'ltr' ? preIcon : NexIcon}  </span>,
                right: <span onClick={() => { onNext(currentPage) }}> {direction === 'ltr' ? NexIcon : preIcon} </span>
            }
        }
        return handleLangugeDirection(lang, "Arrow", handleArrowIcon)

        /*  if (lang === "en" || lang === "fr") {
             return {
                 left: <span onClick={() => { onPrevious(currentPage) }} > <PrevIcon /> </span>,
                 right: <span onClick={() => { onNext(currentPage) }}> <NextIcon /> </span>
             }
         }
         else {
             return {
                 left: <span onClick={() => { onPrevious(currentPage) }}> <NextIcon /> </span>,
                 right: <span onClick={() => { onNext(currentPage) }}> <PrevIcon /> </span>
             }
         } */
    }

    /* console.log("currentPage", currentPage) */

    //console.log(paginationRange)
    {/* <div className="page-buttons">
            <button
              className="pagination-btn"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
            >
              <PrevIcon />
            </button>
            <div className="page-numbers">
              {Array.from({ length: Math.min(totalPages, 3) }, (_, index) => {
                const pageNumber = currentPage - 1 + index;
                const isDisabled = pageNumber >= totalPages || pageNumber < 0;
                return (
                  <button
                    key={pageNumber + 1}
                    className={currentPage === pageNumber + 1 ? "active" : ""}
                    onClick={() => handlePageChange(pageNumber + 1)}
                    disabled={isDisabled}
                  >
                    {pageNumber + 1}
                  </button>
                );
              })}
            </div>
            <button
              className="pagination-btn"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage >= totalPages}
            >
              <NextIcon />
            </button>
          </div> */}

    return (
        <div className="page-buttons">
            <div className="page-numbers">
                {
                    currentPage === 1 ? <></> : (<button className="left"> {Arrow()?.left} </button>)
                }
                {paginationRange?.map((pageNumber: any, index: any) => {

                    if (pageNumber === Dots) {
                        return <button key={index} > --- </button>
                    }
                    return (
                        <button id={index} key={index} className={`pagination-btn ${pageNumber === currentPage ? "active" : "link"}`} onClick={() => { onPageClick(pageNumber - 1) }}>
                            {pageNumber}
                        </button>
                    )

                })}
                {
                    currentPage === lastPage ? <></> : (<button className="right"> {Arrow()?.right} </button>)
                }
            </div>



        </div>
    )
}

export default React.memo(CustomPagination);

/* function setCurrentpage(arg0: number) {
    throw new Error("Function not implemented.");
} */
